import { createContext } from 'react';

/** Reception's existing master/detail host. Only explicitly marked work
 * surfaces dock here; confirmations and other roles retain modal semantics. */
export const WorkspaceSurfaceContext = createContext<{
  target: HTMLElement | null;
  onOpenChange: (open: boolean) => void;
} | null>(null);
